import { always } from "../../../base/utils/ramdaEquivalents.utils";
import { makeObservableRouteDef } from "../../../base/utils/routes.utils";
import PageForgotPassword from "./PageForgotPassword.page";

export const ForgotPasswordPageRoute = makeObservableRouteDef({
  identifier: 'forgot-password',
  urlFactory: always('forgot-password'),
  composeTitle: always('Forgot Password'),
  component: PageForgotPassword,
})